import React, { Component } from 'react';
import Select from 'react-select';
import Swal from "sweetalert2/dist/sweetalert2.js";

class ImportForm extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.fileInputRef = React.createRef();
        this.state = {
            selectedTenant: null,
            selectedUser: null,
            users: [],
            usersLoaded: false,
            jsonFile: null,
            jsonData: null,
            jsonPreview: null,
            isImporting: false,
            importResult: null,
            importId: null,
            importStatus: null,
            importProgress: ''
        }
        this.pollingInterval = null;
    }

    handleTenantChange = (selectedOption) => {
        this.setState({
            selectedTenant: selectedOption,
            selectedUser: null,
            users: [],
            usersLoaded: false
        }, () => {
            if (selectedOption) {
                this.loadUsers(selectedOption.value);
            }
        });
    }

    handleUserChange = (selectedOption) => {
        this.setState({
            selectedUser: selectedOption
        });
    }

    loadUsers = (tenantId) => {
        fetch(`/formatos/module_transfers/users/${tenantId}`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            const options = (data.users || []).map(user => ({
                value: user.id,
                label: `${user.username} (${user.second_email})`
            }));
            this.setState({
                users: options,
                usersLoaded: true,
                selectedUser: options.length > 0 ? options[0] : null
            });
        });
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            this.setState({
                jsonFile: null,
                jsonData: null,
                jsonPreview: null
            });
            return;
        }

        if (!file.name.endsWith('.json')) {
            Swal.fire({
                icon: 'error',
                title: 'Archivo invalido',
                text: 'Por favor seleccione un archivo JSON'
            });
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const data = JSON.parse(event.target.result);

                // Validate it's a beewo export
                if (!data.beewo_export || !data.format_category) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Archivo invalido',
                        text: 'El archivo no es una exportacion valida de Beewo'
                    });
                    return;
                }

                this.setState({
                    jsonFile: file,
                    jsonData: data,
                    jsonPreview: this.generatePreview(data)
                });
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al leer archivo',
                    text: 'El archivo no es un JSON valido'
                });
            }
        };
        reader.readAsText(file);
    }

    generatePreview = (data) => {
        const stats = data.beewo_export.statistics || {};
        return {
            version: data.beewo_export.version,
            exportedAt: data.beewo_export.exported_at,
            categoryName: data.format_category.name,
            description: data.format_category.description,
            statistics: {
                formats: stats.formats || 0,
                questions: stats.questions || 0,
                steps: stats.steps || 0,
                subcategories: stats.subcategories || 0
            },
            formats: (data.formats || []).slice(0, 5).map(f => ({
                name: f.name,
                questions_count: (f.questions || []).length
            }))
        };
    }

    handleImport = () => {
        if (!this.state.selectedTenant || !this.state.selectedUser || !this.state.jsonData) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'Debe seleccionar una empresa destino, un usuario y un archivo JSON'
            });
            return;
        }

        Swal.fire({
            title: 'Confirmar importacion',
            html: `
                <p>Esta a punto de importar el modulo:</p>
                <strong>${this.state.jsonPreview.categoryName}</strong>
                <p class="mt-3">a la empresa:</p>
                <strong>${this.state.selectedTenant.label}</strong>
                <p class="mt-3 text-muted">Esta accion creara todos los formatos y preguntas del modulo.</p>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si, importar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            console.log("Swal result:", result);
            console.log("isConfirmed value:", result.isConfirmed);
            console.log("value:", result.value);
            if (result.isConfirmed === true || result.value === true) {
                console.log("Usuario confirmo, llamando performImport");
                this.performImport();
            } else {
                console.log("No confirmado, isConfirmed:", result.isConfirmed);
            }
        }).catch((error) => {
            console.error("Error en Swal:", error);
        });
    }

    performImport = () => {
        console.log("performImport iniciado");
        this.setState({
            isImporting: true,
            importResult: null,
            importId: null,
            importStatus: 'pending',
            importProgress: 'Iniciando importacion...'
        });

        const payload = {
            tenant_id: this.state.selectedTenant.value,
            user_id: this.state.selectedUser.value,
            json_data: this.state.jsonData,
            filename: this.state.jsonFile.name
        };

        fetch(`/formatos/module_transfers/import`, {
            method: 'POST',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {
            if (data.import_id) {
                // Guardar ID e iniciar polling
                this.setState({
                    importId: data.import_id,
                    importProgress: 'Importacion en cola...'
                });
                this.startPolling(data.import_id);
            } else {
                // Error al iniciar
                this.setState({ isImporting: false });
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.error || 'Error al iniciar importacion'
                });
            }
        })
        .catch(error => {
            this.setState({ isImporting: false });
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error de conexion al importar'
            });
        });
    }

    startPolling = (importId) => {
        // Polling cada 2 segundos
        this.pollingInterval = setInterval(() => {
            this.checkImportStatus(importId);
        }, 2000);
    }

    stopPolling = () => {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    componentWillUnmount() {
        this.stopPolling();
    }

    checkImportStatus = (importId) => {
        fetch(`/formatos/module_transfers/import_status/${importId}`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({ importStatus: data.status });

            if (data.status === 'processing') {
                this.setState({ importProgress: 'Procesando modulo...' });
            } else if (data.status === 'completed') {
                // Importacion completada
                this.stopPolling();
                this.setState({
                    isImporting: false,
                    importProgress: '',
                    importResult: {
                        success: true,
                        statistics: data.statistics,
                        warnings: data.warnings || []
                    }
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Importacion exitosa',
                    html: `
                        <p>El modulo se ha importado correctamente.</p>
                        <p class="mt-2">
                            <strong>Formatos creados:</strong> ${data.statistics?.formats_created || 0}<br>
                            <strong>Preguntas creadas:</strong> ${data.statistics?.questions_created || 0}
                        </p>
                        ${data.warnings?.length > 0 ? `<p class="text-warning mt-2">${data.warnings.length} advertencias</p>` : ''}
                    `
                });

                // Reset form
                this.setState({
                    jsonFile: null,
                    jsonData: null,
                    jsonPreview: null
                });
                if (this.fileInputRef.current) {
                    this.fileInputRef.current.value = '';
                }

                this.props.loadHistory();

            } else if (data.status === 'failed') {
                // Importacion fallida
                this.stopPolling();
                this.setState({
                    isImporting: false,
                    importProgress: '',
                    importResult: {
                        success: false,
                        errors: [data.error]
                    }
                });

                Swal.fire({
                    icon: 'error',
                    title: 'Error al importar',
                    text: data.error
                });
            }
            // Si es 'pending' o 'processing', seguir haciendo polling
        })
        .catch(error => {
            console.error('Error checking import status:', error);
            // No detener el polling por errores de red temporales
        });
    }

    formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-CO', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    render() {
        const tenantOptions = this.props.tenants.map(t => ({
            value: t.id,
            label: t.name
        }));

        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">
                                <i className="fas fa-upload mr-2"></i>
                                Importar Modulo
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label>Empresa (Destino)</label>
                                <Select
                                    value={this.state.selectedTenant}
                                    onChange={this.handleTenantChange}
                                    options={tenantOptions}
                                    placeholder="Seleccione la empresa destino..."
                                    isClearable
                                />
                            </div>

                            <div className="form-group">
                                <label>Usuario Propietario</label>
                                <Select
                                    value={this.state.selectedUser}
                                    onChange={this.handleUserChange}
                                    options={this.state.users}
                                    placeholder={this.state.selectedTenant ? "Seleccione un usuario..." : "Primero seleccione una empresa"}
                                    isDisabled={!this.state.selectedTenant}
                                    isClearable
                                />
                                <small className="form-text text-muted">
                                    Este usuario sera el propietario de los formatos creados
                                </small>
                            </div>

                            <div className="form-group">
                                <label>Archivo JSON</label>
                                <div className="custom-file">
                                    <input
                                        type="file"
                                        className="custom-file-input"
                                        id="jsonFileInput"
                                        accept=".json"
                                        onChange={this.handleFileChange}
                                        ref={this.fileInputRef}
                                    />
                                    <label className="custom-file-label" htmlFor="jsonFileInput">
                                        {this.state.jsonFile ? this.state.jsonFile.name : 'Seleccione un archivo...'}
                                    </label>
                                </div>
                            </div>

                            <button
                                className="btn btn-success btn-block mt-4"
                                onClick={this.handleImport}
                                disabled={!this.state.selectedTenant || !this.state.selectedUser || !this.state.jsonData || this.state.isImporting}
                            >
                                {this.state.isImporting ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                        {this.state.importProgress || 'Importando...'}
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-upload mr-2"></i>
                                        Importar Modulo
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">
                                <i className="fas fa-file-code mr-2"></i>
                                Contenido del Archivo
                            </h5>
                        </div>
                        <div className="card-body">
                            {this.state.jsonPreview ? (
                                <div>
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div>
                                            <h6 className="mb-1">
                                                <strong>{this.state.jsonPreview.categoryName}</strong>
                                            </h6>
                                            {this.state.jsonPreview.description && (
                                                <p className="text-muted mb-0 small">{this.state.jsonPreview.description}</p>
                                            )}
                                        </div>
                                        <span className="badge badge-secondary">
                                            v{this.state.jsonPreview.version}
                                        </span>
                                    </div>

                                    <small className="text-muted">
                                        Exportado: {this.formatDate(this.state.jsonPreview.exportedAt)}
                                    </small>

                                    <hr />

                                    <div className="row text-center mb-3">
                                        <div className="col-3">
                                            <div className="h5 mb-0 text-primary">
                                                {this.state.jsonPreview.statistics.formats}
                                            </div>
                                            <small className="text-muted">Formatos</small>
                                        </div>
                                        <div className="col-3">
                                            <div className="h5 mb-0 text-success">
                                                {this.state.jsonPreview.statistics.questions}
                                            </div>
                                            <small className="text-muted">Preguntas</small>
                                        </div>
                                        <div className="col-3">
                                            <div className="h5 mb-0 text-info">
                                                {this.state.jsonPreview.statistics.steps}
                                            </div>
                                            <small className="text-muted">Pasos</small>
                                        </div>
                                        <div className="col-3">
                                            <div className="h5 mb-0 text-warning">
                                                {this.state.jsonPreview.statistics.subcategories}
                                            </div>
                                            <small className="text-muted">Subcats</small>
                                        </div>
                                    </div>

                                    <hr />

                                    {this.state.jsonPreview.formats.length > 0 && (
                                        <div>
                                            <h6>Formatos incluidos:</h6>
                                            <ul className="list-group list-group-flush">
                                                {this.state.jsonPreview.formats.map((format, idx) => (
                                                    <li key={idx} className="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
                                                        <span className="small">{format.name}</span>
                                                        <span className="badge badge-primary badge-pill">
                                                            {format.questions_count} preg.
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    <div className="alert alert-info mt-3 mb-0">
                                        <i className="fas fa-info-circle mr-2"></i>
                                        <small>
                                            Al importar se crearan nuevos IDs para todos los elementos.
                                            Las referencias internas se mantendran correctamente.
                                        </small>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center text-muted py-5">
                                    <i className="fas fa-file-upload fa-3x mb-3"></i>
                                    <p>Seleccione un archivo JSON para ver su contenido</p>
                                </div>
                            )}

                            {this.state.importResult && (
                                <div className={`alert mt-3 ${this.state.importResult.success ? 'alert-success' : 'alert-danger'}`}>
                                    {this.state.importResult.success ? (
                                        <>
                                            <i className="fas fa-check-circle mr-2"></i>
                                            <strong>Importacion completada</strong>
                                            {this.state.importResult.warnings?.length > 0 && (
                                                <div className="mt-2">
                                                    <small>Advertencias:</small>
                                                    <ul className="mb-0 pl-3">
                                                        {this.state.importResult.warnings.slice(0, 3).map((w, i) => (
                                                            <li key={i}><small>{w}</small></li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-times-circle mr-2"></i>
                                            <strong>Error en la importacion</strong>
                                            <ul className="mb-0 mt-2 pl-3">
                                                {this.state.importResult.errors?.map((e, i) => (
                                                    <li key={i}><small>{e}</small></li>
                                                ))}
                                            </ul>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ImportForm;
